import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from "@air/primitive-tooltip";
import { tailwindMerge } from "@air/tailwind-variants";
import classNames from "classnames";
import { CustomField } from "~/components/CustomField";
import { getFieldsToRenderAndOverflowCount } from "~/utils/CustomFields";
export const CustomFieldListWithOverflow = (param)=>{
    let { allowedWidth, customFields, className, hasDarkBackground = false, shouldShowTooltip = false, onClick, size = "medium", ["data-testid"]: dataTestId } = param;
    const { fieldsToRender, hiddenFieldsCount } = getFieldsToRenderAndOverflowCount({
        allowedWidth,
        customFields,
        widthPerChar: 10
    });
    if (!fieldsToRender.length) return null;
    return /*#__PURE__*/ _jsxs("button", {
        className: tailwindMerge("mt-0.5 flex w-full items-center justify-start rounded", !!onClick ? "cursor-pointer hover:bg-grey-5" : "cursor-default hover:bg-transparent", className),
        disabled: !onClick,
        onClick: onClick,
        "data-testid": dataTestId,
        onMouseDown: (event)=>event.preventDefault(),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center gap-1",
                children: fieldsToRender.map((field)=>{
                    if (field.value) {
                        if (shouldShowTooltip) {
                            return /*#__PURE__*/ _jsx(Tooltip, {
                                label: field.fieldName,
                                children: /*#__PURE__*/ _jsx(CustomField, {
                                    field: field,
                                    size: size
                                })
                            }, field.id);
                        }
                        return /*#__PURE__*/ _jsx(CustomField, {
                            field: field,
                            size: size
                        }, field.id);
                    }
                    return null;
                })
            }),
            hiddenFieldsCount > 0 && /*#__PURE__*/ _jsx("div", {
                className: "ml-1.5 shrink-0",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: classNames("text-12 font-medium", hasDarkBackground ? "text-white" : "text-black"),
                    children: [
                        "+",
                        hiddenFieldsCount
                    ]
                })
            })
        ]
    });
};
